import * as angular from "angular";
import {IController, IScope, ITimeoutService} from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {SortType} from "../../../commons/types/sort.type";
import {OmsOrderStatusType} from "../../types/oms-order-status.type";
import {OrdersTotalsType} from "../../types/orders-totals.type";
import {PatchOmsOrderRequest} from "../../models/patch-oms-order-request.model";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {DateRangeContextService} from "../../../commons/services/date-range-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {$viewSettingsFactory} from "../../../commons/$viewSettings.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ExportOmsOrdersTranslationsPayloadModel} from "../../models/export-oms-orders-translations-payload.model";
import {ExportType} from "../../../commons/types/export.type";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsService} from "../../services/oms-service.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";
import {PlanningProjectsService} from "../../../planning/services/planning-projects-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {CancellationReason} from "../../../cancellation-reasons/models/cancellationReason.model";
import {AddressQualityEnum} from "../../../addresses/types/address-quality.enum";
import {OrdersFacadeService} from "../../angular/service/orders-facade.service";
import {RouteModel} from "../../../routes/models/route.model";
import {OrderModel} from "../../models/order.model";
import {Subscription} from "rxjs";
import {SchedulingSmsStatusEnum} from "../../types/scheduling-sms-status.enum";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {OmsOrderFilterModel} from "../../models/oms-order-filter.model";
import {OmsOrdersQueryModel} from "../../models/oms-orders-query.model";
import {
  OmsOrdersBulkExportRequestModel,
  OmsOrdersBulkTriggerSchedulingRequestModel
} from "../../models/oms-orders-bulk-requests.model";
import {OmsOrdersFooterActionId, OmsOrdersFooterActionModel} from "../../models/oms-orders-footer-action.model";

export class OmsOrdersViewController implements IController {

  dateRangeTemplateType?: DateRangeTemplateType;
  status: string;
  due: string;
  from: any;
  to: any;
  queryString?: string;
  branchIds: any;
  programTypes: any;
  accountIds: any;
  serviceAreaIds: any;
  noArea: boolean;
  tags: any;
  attempts: any;
  isPacked: boolean;
  schedulingRequired: boolean;
  obligateTimeWindow: boolean;
  fulfillmentDisplayStatus: any;
  noFromLocation: boolean;
  noToLocation: boolean;
  pickupDepotIds: any;
  destinationDepotIds: any;
  selectedQuickFilterId?: string;
  configuredFieldName?: string;
  configuredFieldValue?: string;
  addressQualities: AddressQualityEnum[];
  schedulingSmsStatuses: SchedulingSmsStatusEnum[];

  public orders: OrderModel[];
  public pageName: string;
  private loadLimit: number = 20;
  private omsOrdersRef;
  private totalsLoading = false;
  private totals = {
    canceled: undefined,
    completed: undefined,
    pendingCompletionApproval: undefined,
    dispatched: undefined,
    draft: undefined,
    notScheduled: undefined,
    onHold: undefined,
    partiallyScheduled: undefined,
    pending: undefined,
    scheduled: undefined,
    started: undefined,
    total: undefined
  };
  private filterConfig = {
    customTemplates: undefined,
    includeFilters: undefined,
    bringozFilters: undefined,
    queryString: undefined,
    range: {
      name: undefined,
      dateStart: undefined,
      dateEnd: undefined
    },
    rangeLimit: {
      min: undefined,
      max: undefined
    },
    settings: undefined,
    actions: 1,
    siteId: undefined,
    status: undefined
  };
  private statusList;
  private selectedIds = [];
  private excludeMode = false;
  private infiniteScroll;
  private sortExternalIdType: string;
  private sortSchedulingSmsType: string;
  private sortSlaType: string;
  private sortCreatedAtType: string;
  private sortAccountReferenceNameType: string;
  public isDispatchBulkPanelOpen: boolean = false;
  public milesData: any = {};
  public isDispatchDisabled: boolean = false;
  public ordersTotalsType: typeof OrdersTotalsType = OrdersTotalsType;
  private blockingSearchDatesRangeLimit: number;
  public isExpandedQuery: boolean;
  private pushesTimeoutRef: any;
  private maxUserIdleTimeMinutes: number;
  private quickFiltersRef: any;
  public ordersSubscription: Subscription;
  public isLoadingOrdersSubscription: Subscription;
  public isLoadingOrders: boolean;
  public isInitializedOrdersSubscription: Subscription;
  public isInitializedOrders: boolean;
  public isTableScrollable: boolean;
  public selectedSortValue: any;
  public sortTypesValues: any;
  public canRecoverOrders: boolean;
  public selectedOrders: OrderModel[];
  public selectionFilter: OmsOrderFilterModel;
  public footerActions: OmsOrdersFooterActionModel[] = [];
  public footerExtraActions: OmsOrdersFooterActionModel[] = [];

  /* @ngInject */
  constructor(private $translate, private $scope: IScope, private $omsOrder, private splitService: SplitService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private planningConstants, private commonsService: CommonsService,
              private $infiniteScroll, private $log, private omsRequestsService: OmsRequestsService, private $state, private bringozLoaderService: BringozLoaderService,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private planningDialogService: PlanningDialogService, private $timeout: ITimeoutService, private commonsDialogService: CommonsDialogService,
              private planningProjectsService: PlanningProjectsService, private confirmDialogService: ConfirmDialogService, private omsDialogService: OmsDialogService, private omsService: OmsService, private $mdMedia,
              private moment, private quickFilterContextService: QuickFilterContextService, private $viewSettings: $viewSettingsFactory, private viewFilterSettingsService: ViewFilterSettingsService,
              private dateRangeContextService: DateRangeContextService, private ordersFacadeService: OrdersFacadeService, private commonsConstants, private IAMPermissions, private filePrinter, private fileDownloader) {
    this.pageName = this.$state.current.name;
    this.omsOrdersRef = this.$omsOrder();
    this.statusList = angular.copy(Object.values(OmsOrderStatusType));
    this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
  }

  $onInit() {
    // externalId,asc/desc

    this.canRecoverOrders = this.IAMPermissions.hasRole('site.owner') || this.IAMPermissions.hasRole('super.owner');

    this.quickFiltersRef = this.$viewSettings();
    this.filterConfig.siteId = this.splitService.getSiteId();
    this.filterConfig.settings = this.splitService.getSiteOmsSettings();
    this.isExpandedQuery = this.filterConfig.settings.columns.billingOrder.enabled;
    this.filterConfig.queryString = this.queryString;
    this.filterConfig.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
    this.filterConfig.status = this.status || OmsOrderStatusType.NotScheduled;
    // this.filterConfig.range = this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
    //   ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today());

    this.filterConfig.range = this.from && this.to ? {
      name: undefined,
      dateStart: this.from,
      dateEnd: this.to
    } : this.dateRangeTimeFiltersService.today();

    this.sortTypesValues = {
      sortExternalIdType: {
        asc: 'externalId,asc',
        desc: 'externalId,desc'
      },
      sortSlaType: {
        asc: 'dueTo,asc',
        desc: 'dueTo,desc'
      },
      sortAccountReferenceNameType: {
        asc: 'accountReference.name,asc',
        desc: 'accountReference.name,desc'
      },
      sortCreatedAtType: {
        asc: 'createdAt,asc',
        desc: 'createdAt,desc'
      },
      sortSchedulingSmsType: {
        asc: 'deliverySchedulingStateReference.lastSmsSentTimestamp,asc',
        desc: 'deliverySchedulingStateReference.lastSmsSentTimestamp,desc'
      }
    };

    this.filterConfig.rangeLimit = {
      min: !this.blockingSearchDatesRangeLimit ? undefined : this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').valueOf(),
      max: undefined,
    };
    this.filterConfig.includeFilters = [
      SiteFiltersType.dateRangeTemplateType, SiteFiltersType.branchIds, SiteFiltersType.accountIds,
      SiteFiltersType.serviceAreaIds, SiteFiltersType.noArea, SiteFiltersType.tags, SiteFiltersType.fulfillmentDisplayStatus,
      SiteFiltersType.isPacked, SiteFiltersType.schedulingRequired, SiteFiltersType.obligateTimeWindow,
      SiteFiltersType.noFromLocation, SiteFiltersType.noToLocation, SiteFiltersType.programTypes,
      SiteFiltersType.configuredPackageField, SiteFiltersType.addressQualities,
      SiteFiltersType.schedulingSmsStatuses, SiteFiltersType.depotIds, SiteFiltersType.depotPickup,
      SiteFiltersType.depotDropoff, SiteFiltersType.noPickUpDepot, SiteFiltersType.noDropOffDepot
    ];

    this.filterConfig.bringozFilters = {
      dateRangeTemplateType: this.dateRangeTemplateType,
      dueTo: moment(this.due).endOf('day').toDate(),
      branchIds: this.branchIds,
      accountIds: this.accountIds,
      serviceAreaIds: this.serviceAreaIds,
      [SiteFiltersType.noArea]: this.noArea,
      tags: [],
      isPacked: undefined,
      fulfillmentDisplayStatus: this.fulfillmentDisplayStatus,
      schedulingRequired: this.schedulingRequired,
      obligateTimeWindow: this.obligateTimeWindow,
      noFromLocation: this.noFromLocation,
      noToLocation: this.noToLocation,
      pickupDepotIds: this.pickupDepotIds,
      destinationDepotIds: this.destinationDepotIds,
      programTypes: this.programTypes,
      [SiteFiltersType.schedulingSmsStatuses]: this.schedulingSmsStatuses,
      [SiteFiltersType.configuredFieldName]: this.configuredFieldName || undefined,
      [SiteFiltersType.configuredFieldValue]: this.configuredFieldValue || undefined,
      [SiteFiltersType.addressQualities]: this.addressQualities || []
    }

    // this.viewFilterSettingsService.setServiceAreaIds(this.serviceAreaIds);
    // this.viewFilterSettingsService.setBranchIds(this.branchIds);
    // this.viewFilterSettingsService.setAccountIds(this.accountIds);

    // this.omsOrdersRef.$query(this.getQueryPayload());
    // this.infiniteScroll = this.$infiniteScroll(this.omsOrdersRef, this.loadLimit);

    this._getOrders();
    this.ordersFacadeService.subscribeToChannels();

    this.ordersSubscription = this.ordersFacadeService.selectInfiniteScrollEntities().subscribe(orders => {

      this.orders = angular.copy(orders);

      this.$timeout(() => {
      }, 0)
    });

    this.isLoadingOrdersSubscription = this.ordersFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoadingOrders = isLoading;
      this.$timeout(() => {
      }, 0)
    });

    this.isInitializedOrdersSubscription = this.ordersFacadeService.selectInitialized().subscribe((initialized) => {
      this.isInitializedOrders = initialized;
      this.$timeout(() => {
      }, 0)
    });

    this._setStateParams();
    this.setTotals();

    // Orders Create Event Listener
    // this.omsOrdersRef.$onCreate(this.$scope, (orders) => {
    //
    //   // Filter orders by due date and current status
    //   const filteredOrders = this.filterOrders(orders,
    //     moment(this.filterConfig.bringozFilters.dueTo).valueOf(),
    //     this.filterConfig.status
    //   );
    //
    //   // Add orders to list
    //   if (filteredOrders.length) {
    //     this.infiniteScroll.addItems(_.map(filteredOrders, (o) => {
    //       return o.id;
    //     }));
    //     // if (filteredOrders.length > 1) {
    //     //   this.omsOrdersAlertsService.addedManyInfo(filteredOrders.length);
    //     // } else {
    //     //   this.omsOrdersAlertsService.addedInfo();
    //     // }
    //   }
    //
    //   // //Update totals
    //   // this.setTotals();
    //
    // });

    // Bind User Event Listeners
    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();
  }

  $doCheck() {
    this.isTableScrollable = window.innerWidth < (this.commonsService.calculateTableColumnsTotalWidth(this.filterConfig.settings.columns, this.filterConfig.settings.dynamicColumns, this.commonsConstants.tableColumnSizes['small'] + 250));
  }

  $onDestroy() {
    this._destroyPushesTimer();

    this.ordersFacadeService.clearStore();
    this.ordersSubscription?.unsubscribe();
    this.isLoadingOrdersSubscription?.unsubscribe();
    this.isInitializedOrdersSubscription?.unsubscribe();
  }

  fetchNext() {
    if (this.isLoadingOrders) return;
    this.ordersFacadeService.fetchNext(this._getOrdersQuery(), true);
  }

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._getOrders();
    this._setStateParams();
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this._getOrders();
  }

  onRangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filterConfig.range.name)) {
      this.filterConfig.range = range;

      this.dateRangeContextService.setRange(range.dateStart, range.dateEnd);

      if (this.selectedQuickFilterId && range?.type !== this.filterConfig.bringozFilters.dateRangeTemplateType) {
        this.selectedQuickFilterId = undefined;
      }

      this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
      this._setStateParams();
      this._getOrders();
      this.setTotals();
    }
  }

  onStatusChange(status) {
    this.filterConfig.status = status;
    this.selectedIds = [];
    this.selectedOrders = [];
    this.excludeMode = false;
    this._setStateParams();
    this._getOrders();
    this.setTotals();
  }

  onDateChange(selectedDate) {
    this.filterConfig.bringozFilters.dueTo = selectedDate;
    this._setStateParams();
    this._getOrders();
    this.setTotals();
  }

  onDateSortByChange(isByCreatedDate) {
    this._setStateParams();
    this._getOrders();
    this.setTotals();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.filterConfig.bringozFilters = filters;


    if (!!filters.dateRangeTemplateType) {
      this.filterConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this.isDispatchBulkPanelOpen = false;
    this._setStateParams();
    this._getOrders();
    this.setTotals();
  }

  onViewSettingsChange(settings) {
    const oldSettingsRef = angular.copy(this.filterConfig.settings);

    this.filterConfig.settings = settings;
    this.splitService.setSiteOmsSettings(settings);

    if (!_.isEqual(_.get(oldSettingsRef, 'filterByCreatedAt'), _.get(settings, 'filterByCreatedAt'))) {
      this._setStateParams();
      this._getOrders();
      this.setTotals();
    }

    if (!_.isEqual(_.get(oldSettingsRef, 'columns.billingOrder.enabled'), _.get(settings, 'columns.billingOrder.enabled'))) {
      this.isExpandedQuery = this.filterConfig.settings.columns.billingOrder.enabled;
      if (this.isExpandedQuery) {
        this._getOrders();
      }
    }

    this.omsOrdersAlertsService.viewSettingsSuccess();
  }

  onSelectOrdersChanged(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.selectedOrders = this.orders?.filter(o => !!this.selectedIds?.includes(o.id))
    this.excludeMode = excludeMode;
    this.selectionFilter = this._getSelectionFilter();
    this._setFooterActions();
    this.$scope.$applyAsync();
  }

  onFooterActionSelect(actionId: OmsOrdersFooterActionId, event) {
    switch (actionId) {
      case 'EditMetaData':
        return this.onEditMetaData(event);
      case 'SendToDispatch':
        return this.openDispatchBulkPanel();
      case 'Planning':
        return this.onMoveToPlanning(event);
      case 'SendSchedulingWhatsapp':
        return this.onSendSchedulingInBulk('WHATSAPP');
      case 'SendSchedulingSms':
        return this.onSendSchedulingInBulk('SMS');
      case 'ScheduleSelfPickup':
        return this.onScheduleSelfPickup(event);
      case 'BulkEdit':
        return this.onBulkEdit();
      case 'Cancel':
        return this.onCancelOrders();
    }
  }

  onClearSelection() {
    this.selectedIds = [];
    this.selectedOrders = [];
    this.excludeMode = false;
  }

  onMoveToPlanning(event) {

    const selectedIds = this.excludeMode ? [] : this.selectedIds;
    const excludedIds = this.excludeMode ? this.selectedIds : [];

    this.planningDialogService.createProject(event, true)
      .then((project) => {

        const isNotTag = !!_.find(this.filterConfig.bringozFilters.tags, (t) => {
          return t === 'noTag';
        }) ? true : undefined

        const {pickupDepotIds, destinationDepotIds, depotIds} = this._getDepotIdsFilter();

        this.bringozLoaderService.on();
        this.planningProjectsService.createProjectWithOrders(
          project,
          selectedIds,
          excludedIds,
          (this.filterConfig.status === 'Total' || this.filterConfig.status === 'PartiallyScheduled') ? undefined : this.filterConfig.status,
          this.filterConfig.status === 'PartiallyScheduled' ? true : undefined,
          this.filterConfig.range.dateStart,
          this.filterConfig.range.dateEnd,
          this.filterConfig.bringozFilters.branchIds,
          this.filterConfig.bringozFilters.accountIds,
          this.filterConfig.bringozFilters.serviceAreaIds,
          this.filterConfig.bringozFilters.tags,
          isNotTag,
          this.filterConfig.bringozFilters.attempts,
          this.filterConfig.bringozFilters.isPacked,
          this.filterConfig.settings.filterByCreatedAt,
          this.filterConfig.bringozFilters.fulfillmentDisplayStatus,
          this.filterConfig.bringozFilters.schedulingRequired,
          this.filterConfig.bringozFilters.obligateTimeWindow,
          this.filterConfig.bringozFilters.noFromLocation,
          this.filterConfig.bringozFilters.noToLocation,
          this.filterConfig.bringozFilters.programTypes,
          this.filterConfig.bringozFilters.addressQualities,
          this.filterConfig.bringozFilters.schedulingSmsStatuses,
          pickupDepotIds,
          destinationDepotIds,
          depotIds,
          this.filterConfig.queryString,
          this.filterConfig.bringozFilters.noArea
        )
          .then((createdProject: any) => {
            this.$state.go(this.planningConstants.states.project, {projectId: createdProject.id});
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed', error);
      })
  }


  onBulkEdit() {
    const ordersCount = this.excludeMode ?
      (this.totals[this.ordersTotalsType[this.filterConfig.status]] - this.selectedIds.length) :
      this.selectedIds.length;

    this.omsDialogService.bulkEditOrders(ordersCount, this.filterConfig.status)
      .then((patchOmsOrderRequest: PatchOmsOrderRequest) => {
        this.omsService.bulkUpdateOrders({filter: this._getSelectionFilter(), request: patchOmsOrderRequest});
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed', error);
      })
  }

  // onScheduleDeliveries(event) {
  //
  //   const selectedIds = this.excludeMode ? [] : this.selectedIds;
  //   const excludedIds = this.excludeMode ? this.selectedIds : [];
  //
  //   this.omsDialogService.scheduleDeliveries(event)
  //     .then((schedule) => {
  //       this.bringozLoaderService.on();
  //       this.omsRequests.scheduleDeliveries(
  //         selectedIds,
  //         schedule.programType,
  //         schedule.notBefore,
  //         schedule.notAfter,
  //         excludedIds,
  //         this.filterConfig.range.dateStart,
  //         this.filterConfig.range.dateEnd,
  //         this.filterConfig.status,
  //         this.filterConfig.bringozFilters.branchIds,
  //         this.filterConfig.bringozFilters.accountIds,
  //         this.filterConfig.bringozFilters.serviceAreaIds,
  //         this.filterConfig.bringozFilters.tags,
  //         schedule.noTags,
  //         this.filterConfig.bringozFilters.attempts,
  //         this.filterConfig.bringozFilters.isPacked,
  //         this.filterConfig.bringozFilters.schedulingRequired,
  //         this.filterConfig.bringozFilters.obligateTimeWindow)
  //         .then(() => {
  //           this.OMSOrdersAlerts.scheduleOrderSuccess();
  //         })
  //         .catch(() => {
  //           this.OMSOrdersAlerts.scheduleOrderError();
  //         })
  //         .finally(() => {
  //           this.bringozLoaderService.off();
  //         });
  //     })
  //     .catch(() => {
  //       this.$log.debug('Closed Dialog');
  //     });
  // }

  onScheduleSelfPickup(event) {

    const selectedIds = this.excludeMode ? [] : this.selectedIds;
    const excludedIds = this.excludeMode ? this.selectedIds : [];

    const isNotTag = !!_.find(this.filterConfig.bringozFilters.tags, (t) => {
      return t === 'noTag';
    }) ? true : undefined

    const {pickupDepotIds, destinationDepotIds, depotIds} = this._getDepotIdsFilter();

    this.planningDialogService.createProject(event, true)
      .then((project) => {
        this.bringozLoaderService.on();
        this.planningProjectsService.createProjectWithOrders(
          project,
          selectedIds,
          excludedIds,
          (this.filterConfig.status === 'Total' || this.filterConfig.status === 'PartiallyScheduled') ? undefined : this.filterConfig.status,
          (this.filterConfig.status === 'PartiallyScheduled' ? true : undefined),
          this.filterConfig.range.dateStart,
          this.filterConfig.range.dateEnd,
          this.filterConfig.bringozFilters.branchIds,
          this.filterConfig.bringozFilters.accountIds,
          this.filterConfig.bringozFilters.serviceAreaIds,
          this.filterConfig.bringozFilters.tags,
          isNotTag,
          this.filterConfig.bringozFilters.attempts,
          this.filterConfig.bringozFilters.isPacked,
          this.filterConfig.settings.filterByCreatedAt,
          this.filterConfig.bringozFilters.fulfillmentDisplayStatus,
          this.filterConfig.bringozFilters.schedulingRequired,
          this.filterConfig.bringozFilters.obligateTimeWindow,
          this.filterConfig.bringozFilters.noFromLocation,
          this.filterConfig.bringozFilters.noToLocation,
          this.filterConfig.bringozFilters.programTypes,
          this.filterConfig.bringozFilters.addressQualities,
          this.filterConfig.bringozFilters.schedulingSmsStatuses,
          pickupDepotIds,
          destinationDepotIds,
          depotIds,
          this.filterConfig.queryString,
          this.filterConfig.bringozFilters.noArea
        )
          .then((createdProject: any) => {
            this.$state.go('planning.project', {id: createdProject.id});
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed', error);
      });
  }

  onCancelOrders() {

    const selectedIds = this.excludeMode ? [] : this.selectedIds;

    this.omsDialogService.createOrderCancellationReason(undefined)
      .then((orderCancellationReason: CancellationReason) => {
        this.bringozLoaderService.on();
        this.omsRequestsService.cancelOrders({
          filter: this._getSelectionFilter(),
          cancellationReason: orderCancellationReason
        })
          .then((canceledOrders) => {
            if (canceledOrders.length > 1) {
              this.omsOrdersAlertsService.cancelManySuccess();
            } else {
              this.omsOrdersAlertsService.cancelSuccess()
            }
            this.selectedIds = [];
            this.excludeMode = false;
          })
          .catch(() => {
            if (selectedIds.length > 1) {
              this.omsOrdersAlertsService.cancelManyError();
            } else {
              this.omsOrdersAlertsService.cancelError();
            }
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      })
      .catch(() => {
        this.$log.debug('Closed Dialog');
      });
  }

  onBulkDispatch() {
    const dispatchTimeWindowsPerLegRequest = {
      firstMile: {
        active: this.milesData.firstMile.active,
        pickupNotBefore: this.milesData.firstMile.isPerServiceOrTask === 'perService' ? this.milesData.firstMile.deliveryStartTime : this.milesData.firstMile.originStartTime,
        pickupNotAfter: this.milesData.firstMile.isPerServiceOrTask === 'perService' ? this.milesData.firstMile.deliveryEndTime : this.milesData.firstMile.originEndTime,
        destinationNotBefore: this.milesData.firstMile.deliveryStartTime,
        destinationNotAfter: this.milesData.firstMile.deliveryEndTime,
      },
      middleMile: {
        active: this.milesData.middleMile.active,
        pickupNotBefore: this.milesData.middleMile.isPerServiceOrTask === 'perService' ? this.milesData.middleMile.deliveryStartTime : this.milesData.middleMile.originStartTime,
        pickupNotAfter: this.milesData.middleMile.isPerServiceOrTask === 'perService' ? this.milesData.middleMile.deliveryEndTime : this.milesData.middleMile.originEndTime,
        destinationNotBefore: this.milesData.middleMile.deliveryStartTime,
        destinationNotAfter: this.milesData.middleMile.deliveryEndTime,
      },
      lastMile: {
        active: this.milesData.lastMile.active,
        pickupNotBefore: this.milesData.lastMile.isPerServiceOrTask === 'perService' ? this.milesData.lastMile.deliveryStartTime : this.milesData.lastMile.originStartTime,
        pickupNotAfter: this.milesData.lastMile.isPerServiceOrTask === 'perService' ? this.milesData.lastMile.deliveryEndTime : this.milesData.lastMile.originEndTime,
        destinationNotBefore: this.milesData.lastMile.deliveryStartTime,
        destinationNotAfter: this.milesData.lastMile.deliveryEndTime,
      },
      manualBranchIds: this.milesData.manualBranchIds
    }

    this.bringozLoaderService.on();
    this.isDispatchDisabled = true;
    this.omsRequestsService.bulkDispatch({
      filter: this._getSelectionFilter(),
      sendSms: false,
      payload: dispatchTimeWindowsPerLegRequest
    })
      .then(() => {
        this.omsOrdersAlertsService.dispatchBulkSuccess();
        this.selectedIds = [];
        this.selectedOrders = [];
        this.excludeMode = false;
      })
      .catch(() => {
        this.omsOrdersAlertsService.dispatchBulkError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.isDispatchDisabled = false;
        this.isDispatchBulkPanelOpen = false;
      })

  }

  onAssign(orderId, $event) {
    this.omsDialogService.assignOrder(orderId, $event)
      .then((supplier) => {
        this._assignToSupplier(orderId, supplier);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onExternalIdSortTypeChange(sortType) {
    this.sortExternalIdType = sortType;
    this.sortSlaType = undefined;
    this.sortCreatedAtType = undefined;
    this.sortAccountReferenceNameType = undefined;
    this.sortSchedulingSmsType = undefined;

    this._getOrders();
  }

  onSchedulingSmsSortTypeChange(sortType: SortType) {
    this.sortSchedulingSmsType = sortType;
    this.sortExternalIdType = undefined;
    this.sortSlaType = undefined;
    this.sortCreatedAtType = undefined;
    this.sortAccountReferenceNameType = undefined;

    this._getOrders();
  }

  onAccountReferenceNameSortTypeChange(sortType) {
    this.sortAccountReferenceNameType = sortType;
    this.sortExternalIdType = undefined;
    this.sortSlaType = undefined;
    this.sortCreatedAtType = undefined;
    this.sortSchedulingSmsType = undefined;
    this._getOrders();
  }

  onSlaSortTypeChange(sortType) {
    this.sortSlaType = sortType;
    this.sortExternalIdType = undefined;
    this.sortAccountReferenceNameType = undefined;
    this.sortCreatedAtType = undefined;
    this.sortSchedulingSmsType = undefined;
    this._getOrders();
  }

  onCreatedAtSortTypeChange(sorType) {
    this.sortCreatedAtType = sorType;
    this.sortSlaType = undefined;
    this.sortExternalIdType = undefined;
    this.sortAccountReferenceNameType = undefined;
    this.sortSchedulingSmsType = undefined;
    this._getOrders();

  }

  openDispatchBulkPanel() {
    this.isDispatchBulkPanelOpen = !this.isDispatchBulkPanelOpen;
  }

  onCloseBulkDispatchPanel() {
    this.isDispatchBulkPanelOpen = !this.isDispatchBulkPanelOpen;
  }

  onChangeMilesData(milesData) {
    this.milesData = milesData;
  }

  onFilterByType(type, value) {
    const bringozFiltersCopy = angular.copy(this.filterConfig.bringozFilters);
    if (_.isArray(bringozFiltersCopy[type])) {
      if (_.isArray(value)) {
        bringozFiltersCopy[type] = _.uniq(bringozFiltersCopy[type].concat(value));
      } else {
        if (!_.includes(bringozFiltersCopy[type], value)) {
          bringozFiltersCopy[type].push(value);
        }
      }
    } else {
      bringozFiltersCopy[type] = value;
    }

    this.filterConfig.bringozFilters = bringozFiltersCopy;
    this._setStateParams();
    this._getOrders();
    this.setTotals();
  }

  onAddNote(orderId) {
    this.omsService.onAddNote(undefined, orderId);
  }

  onSetOrderOnHold(orderId) {
    this.omsService.onSetOrderOnHold(orderId);
  }

  onResumeOrder(orderId) {
    this.omsDialogService.onResumeOrder().then(res => {
      this.resumeOrder(res, orderId);
    })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onManuallyCompleteOrder(orderId) {
    this.omsService.manuallyCompleteOrder(orderId);
  }

  onDuplicate(orderId) {
    this.$state.go('order.duplicate', {id: orderId}, {notify: true, reload: false});
  }

  onEdit(order) {
    order.status !== 'Completed' ? this.$state.go('order.edit', {id: order.id}, {
      notify: true,
      reload: false
    }) : this._editCompletedOrder(order);
  }

  onPrintBillOfLading(orderId) {
    this.omsService.onGetBOLOrderIdToPdf(orderId)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onDownloadBillOfLading(orderId) {
    this.omsService.onGetBOLOrderIdToPdf(orderId)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onSendSchedulingSMSClicked(order) {
    if (order.status !== 'NotScheduled') {
      this.omsDialogService.confirmReschedulingForm()
        .then((result) => {
          if (result) {
            this.omsService.sendSchedulingLink(order.id, result);
          }
        })
        .catch(() => {
        })
    } else {
      this.omsService.sendSchedulingLink(order.id);
    }
  }

  onSendSchedulingWhatsappClicked(order) {
    if (order.status !== 'NotScheduled') {
      this.omsDialogService.confirmReschedulingForm()
        .then((result) => {
          if (result) {
            this.omsService.sendSchedulingLinkWhatsapp(order.id, result);
          }
        })
        .catch(() => {
        })
    } else {
      this.omsService.sendSchedulingLinkWhatsapp(order.id);
    }
  }

  onRecover(orderId) {
    this.omsService.recoverOrder(orderId)
      .catch((error) => {
        this.$log.error('Failed to recover order', error);
      })
  }

  onCancelOrder(orderId, event) {
    this.omsService.onCancelOrder(orderId, event);
  }

  canSendScheduling() {
    if (this.excludeMode) {
      return true;
    } else if (!this.selectedIds?.length) {
      return false;
    } else {
      return !this.selectedOrders?.find(o => o.status === 'Completed' || o.status === 'Canceled');
    }
  }

  onSendSchedulingInBulk(type: 'SMS' | 'WHATSAPP') {
    const scheduledOrders = this.selectedOrders.filter(o => o.status === 'Scheduled');

    if (this.excludeMode || !scheduledOrders?.length) {
      this.bulkSendScheduling(type);
    } else {
      this.omsDialogService.confirmReschedulingForm(undefined, scheduledOrders.map(o => o.id))
        .then((result) => {
          if (result) {
            this.bulkSendScheduling(type);
          }
        })
    }

    // const scheduledOrders = this.selectedOrders.filter(o => o.status === 'Scheduled');
    // if (!!scheduledOrders.length) {
    //   this.omsDialogService.confirmReschedulingForm(undefined, scheduledOrders.map(o => o.id))
    //     .then((result) => {
    //       if (result) {
    //         this.bulkSendSchedulingSms();
    //       }
    //     })
    // } else {
    //   this.bulkSendSchedulingSms();
    // }

  }

  private bulkSendScheduling(type: 'SMS' | 'WHATSAPP') {
    const request: OmsOrdersBulkTriggerSchedulingRequestModel = {
      filter: this._getSelectionFilter(),
      ignoreOrderStatus: !this.excludeMode
    };

    if (type === 'SMS') {
      this.omsService.bulkSendSchedulingLink(request);
    }
    if (type === 'WHATSAPP') {
      this.omsService.bulkSendSchedulingLinkWhatsapp(request);
    }

  }

  private _editCompletedOrder(order) {
    const orderEditStatus = this.omsService.checkOrderEditStatus(order.omsEditableStatus);
    if (orderEditStatus.isEditable) {
      const orderCopy = angular.copy(order);
      this.omsDialogService.editCompletedOrder(orderCopy)
        .then((updatedOrder) => {
          this._updateCompletedOrder(updatedOrder);
        })
    } else {
      this.omsDialogService.blockedOrderEditReasonsList(orderEditStatus.reasons);
    }
  }

  private _updateCompletedOrder(order) {
    this.omsService.updateCompletedOrder(order.id, order)
  }

  private resumeOrder(isSendSchedulingFormToClient, orderId) {
    this.omsService.resumeOrder(orderId, isSendSchedulingFormToClient);
  }


  onExportTable(event, exportType: ExportType) {
    // const displayedOrderMetaFieldsKeys: string[] = [];
    // let displayedOrderMetaFieldsTitleList: string[] = [];
    // if (this.filterConfig.settings?.dynamicColumns?.length) {
    //   this.filterConfig.settings.dynamicColumns.forEach((d) => {
    //     if (!!d.enabled) {
    //       displayedOrderMetaFieldsKeys.push(d.key);
    //       displayedOrderMetaFieldsTitleList.push(d.title);
    //     }
    //   })
    // }

    // Nothing selected exports the whole grid; otherwise the selection (explicit ids or exclude mode).
    const request: OmsOrdersBulkExportRequestModel = {
      filter: (this.excludeMode || this.selectedIds?.length) ? this._getSelectionFilter() : this._getGridFilter(),
      exportType: exportType,
      zoneId: this.splitService.getTimeZone(),
      fieldTranslationMap: this._getExportTablePayload(),
      fieldsMap: this._getExportFieldsMapPayload(),
      metaDataMap: this._getExportMetadataMapPayload()
    }

    const totalGroup =  this.filterConfig.status.toLowerCase();
    const matchedKey = Object.keys(this.totals).find(
      key => key.toLowerCase() === totalGroup.toLowerCase()
    );
    let extraText;

    const text = 'Are you sure you want to export orders?';
    if (exportType === ExportType.Excel) {
      if (this.totals[matchedKey] > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Orders to File', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this.omsService.exportOrdersTable(this._getSortType(), request);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (this.totals[matchedKey] > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Orders to File', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this.omsService.exportOrdersTable(this._getSortType(), request);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');

        });
    }
  }

  onEditMetaData($event) {
    const metaData = this.splitService.getOmsMetadataSettings();
    this.commonsDialogService.editMetaData($event, this.selectedIds, metaData)
      .then((res: { ids: string[], metaData: { key: string, value: string }[] }) => {
        this.omsService.updateOrdersMetaData({filter: this._getSelectionFilter(), metaData: res.metaData});
      })
  }

  private _getExportTablePayload(): ExportOmsOrdersTranslationsPayloadModel {
    return {
      externalId: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.externalId'),
      accountName: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.accountName'),
      billingOrderPrice: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.billingOrderPrice'),
      contactDestination: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.contactDestination'),
      contactPickup: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.contactPickup'),
      createdTime: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.createdTime'),
      fulfillmentStatus: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.fulfillmentStatus'),
      itemBarcodes: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.itemBarcodes'),
      itemIds: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.itemIds'),
      itemTypes: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.itemTypes'),
      locationDestination: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.locationDestination'),
      locationPickup: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.locationPickup'),
      notAfter: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.notAfter'),
      notesDestination: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.notesDestination'),
      notesPickup: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.notesPickup'),
      orderId: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.orderId'),
      phoneDestination: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.phoneDestination'),
      phonePickup: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.phonePickup'),
      proNumber: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.proNumber'),
      programType: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.programType'),
      referenceIds: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.referenceIds'),
      schedulingSms: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.schedulingSms'),
      pallets: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.pallets'),
      accountExternalId: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.accountExternalId'),
      destinationCity: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.destinationCity'),
      destinationStreet: this.$translate.instant('EXPORT_OMS_ORDERS_TABLE_COLUMNS.destinationStreet'),
    }
  }

  private _getExportFieldsMapPayload(): any {
    const columns = this.filterConfig.settings.columns;

    return {
      externalId: true,
      accountName: columns?.account?.enabled,
      billingOrderPrice: columns?.billingOrder?.enabled,
      contactDestination: columns?.contact?.enabled,
      contactPickup: columns?.contact?.enabled,
      createdTime: columns?.createdAt?.enabled,
      fulfillmentStatus: columns?.fulfillmentStatus?.enabled,
      itemBarcodes: columns?.itemsBarcodes?.enabled,
      itemIds: columns?.itemsIds?.enabled,
      itemTypes: columns?.itemsTypes?.enabled,
      locationDestination: columns?.location?.enabled,
      locationPickup: columns?.location?.enabled,
      notAfter: columns?.sla?.enabled,
      notesDestination: columns?.notes?.enabled,
      notesPickup: columns?.notes?.enabled,
      pallets: columns?.pallets?.enabled,
      orderId: true,
      phoneDestination: columns?.phone?.enabled,
      phonePickup: columns?.phone?.enabled,
      proNumber: columns?.proNumber?.enabled,
      programType: columns?.programType?.enabled,
      referenceIds: columns?.referenceIds?.enabled,
      schedulingSms: columns?.schedulingSms?.enabled,
      accountExternalId: columns?.account?.enabled,
      destinationCity: columns?.location?.enabled,
      destinationStreet: columns?.location?.enabled,
    }
  }

  private _getExportMetadataMapPayload() {
    const filteredColumns = (this.filterConfig.settings?.dynamicColumns || []).filter((c) => {
      return !!c.active && !!c.enabled;
    })
    const metaDataMapPayload = _.reduce(
      filteredColumns,
      (result, column) => {
        result[column.key] = true;
        return result;
      },
      {} as Record<string, boolean>
    );
    return metaDataMapPayload;
  }

  private _setStateParams() {
    this.$state.go('.', {
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
      status: this.filterConfig.status,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      queryString: this.filterConfig.queryString,
      filterByCreatedAt: this.filterConfig.settings.filterByCreatedAt,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      serviceAreaIds: this.filterConfig.bringozFilters.serviceAreaIds,
      noArea: this.filterConfig.bringozFilters.noArea,
      tags: this.filterConfig.bringozFilters.tags,
      fulfillmentDisplayStatus: this.filterConfig.bringozFilters.fulfillmentDisplayStatus,
      attempts: this.filterConfig.bringozFilters.attempts,
      isPacked: this.filterConfig.bringozFilters.isPacked,
      schedulingRequired: this.filterConfig.bringozFilters.schedulingRequired,
      obligateTimeWindow: this.filterConfig.bringozFilters.obligateTimeWindow,
      noFromLocation: this.filterConfig.bringozFilters.noFromLocation,
      noToLocation: this.filterConfig.bringozFilters.noToLocation,
      selectedQuickFilterId: this.selectedQuickFilterId,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      addressQualities: this.filterConfig.bringozFilters.addressQualities,
      schedulingSmsStatuses: this.filterConfig.bringozFilters.schedulingSmsStatuses
    }, {notify: false, reload: false, location: 'replace'});
  }

  private _assignToSupplier(orderId, supplier) {
    this.omsService.assignToSupplier(orderId, supplier)
      .then((res) => {
      })
      .catch((error) => {
        this.$log.error('Failed to assign an order to supplier', error);
      })
  }

  private _getIsNotTag(): boolean {
    return !_.get(this.filterConfig, 'bringozFilters.tags.length') ? undefined :
      !!_.find(this.filterConfig.bringozFilters.tags, (t) => {
        return t === 'noTag';
      });
  }

  private _getDepotIdsFilter(): { pickupDepotIds: string[], destinationDepotIds: string[], depotIds: string[] } {
    let pickupDepotIds = [];
    let destinationDepotIds = [];

    pickupDepotIds = this.filterConfig.bringozFilters.noPickUpDepot ? undefined : this.filterConfig.bringozFilters.depotIds ?? undefined;
    destinationDepotIds = this.filterConfig.bringozFilters.noDropOffDepot ? undefined : this.filterConfig.bringozFilters.depotIds ?? undefined;

    if (this.filterConfig.bringozFilters.noPickUpDepot && this.filterConfig.bringozFilters.noDropOffDepot) {
      pickupDepotIds = this.filterConfig.bringozFilters.depotIds ?? undefined;
      destinationDepotIds = this.filterConfig.bringozFilters.depotIds ?? undefined;
    }

    if (pickupDepotIds?.length && destinationDepotIds?.length) {
      return {pickupDepotIds: undefined, destinationDepotIds: undefined, depotIds: _.uniq([...pickupDepotIds, ...destinationDepotIds])};
    }

    return {pickupDepotIds, destinationDepotIds, depotIds: undefined};
  }

  /**
   * The active filters as the server's OmsOrderFilter body, without the status tab. This is what
   * the totals count over - each status chip is one bucket of it.
   */
  private _getActiveFilter(): OmsOrderFilterModel {
    const filters = this.filterConfig.bringozFilters;
    const {pickupDepotIds, destinationDepotIds, depotIds} = this._getDepotIdsFilter();
    const filterByCreatedAt = !!this.filterConfig.settings.filterByCreatedAt;
    const {dateStart, dateEnd} = this.filterConfig.range;

    const filter: OmsOrderFilterModel = {
      dueFrom: filterByCreatedAt ? undefined : dateStart,
      dueTo: filterByCreatedAt ? undefined : dateEnd,
      createdAtFrom: filterByCreatedAt ? dateStart : undefined,
      createdAtTo: filterByCreatedAt ? dateEnd : undefined,
      branchIds: filters.branchIds,
      accountIds: filters.accountIds,
      serviceAreaIds: filters.serviceAreaIds,
      noServiceArea: filters.noArea,
      tags: filters.tags,
      noTags: this._getIsNotTag(),
      attempts: filters.attempts,
      packed: filters.isPacked,
      schedulingRequired: filters.schedulingRequired,
      obligateTimeWindow: filters.obligateTimeWindow,
      flDisplayStatuses: filters.fulfillmentDisplayStatus,
      noFromLocation: filters.noFromLocation,
      noToLocation: filters.noToLocation,
      pickupDepotIds: pickupDepotIds,
      destinationDepotIds: destinationDepotIds,
      depotIds: depotIds,
      programTypes: filters.programTypes,
      configuredFieldId: filters.configuredFieldName,
      configuredFieldValues: filters.configuredFieldValue ? [filters.configuredFieldValue] : undefined,
      addressResolveQualityGroups: filters.addressQualities,
      deliverySchedulingStatuses: filters.schedulingSmsStatuses,
      searchTerm: this.filterConfig.queryString || undefined
    };

    return _.omitBy(filter, _.isUndefined);
  }

  /**
   * The rows the grid shows: the active filters narrowed to the selected status tab.
   */
  private _getGridFilter(): OmsOrderFilterModel {
    const status = this.filterConfig.status;
    return _.omitBy({
      ...this._getActiveFilter(),
      statuses: (status === 'Total' || status === 'PartiallyScheduled') ? undefined : [status],
      partiallyScheduled: status === 'PartiallyScheduled' ? true : undefined
    }, _.isUndefined);
  }

  /**
   * The current selection, the filter every bulk action takes: explicit ids, or in exclude mode
   * ("select all") the grid's filter minus the unchecked rows.
   */
  private _getSelectionFilter(): OmsOrderFilterModel {
    if (!this.excludeMode) {
      return {ids: this.selectedIds};
    }
    return {...this._getGridFilter(), excludedIds: this.selectedIds};
  }

  private _getOrdersQuery(): OmsOrdersQueryModel {
    return {
      filter: this._getGridFilter(),
      size: this.loadLimit,
      sort: _.get(this.selectedSortValue, 'value'),
      expand: this.isExpandedQuery
    };
  }

  /**
   * The bulk actions available for the current selection, mirroring the visibility rules the
   * Actions menu used before the footer replaced it.
   */
  private _setFooterActions() {
    const status = this.filterConfig.status;
    if (status === 'Canceled') {
      this.footerActions = [];
      this.footerExtraActions = [];
      return;
    }

    const isCompleted = status === 'Completed';
    const canSendScheduling = this.canSendScheduling();
    const actions = _.compact<OmsOrdersFooterActionModel>([
      !this.excludeMode && {id: 'EditMetaData', title: 'Edit Meta Data', icon: 'edit-outline'},
      !isCompleted && {id: 'SendToDispatch', title: 'Send to dispatch', icon: 'dispatch'},
      !isCompleted && this.IAMPermissions.hasPermission('planning.create') && {id: 'Planning', title: 'Planning', icon: 'planning'},
      canSendScheduling && {id: 'SendSchedulingWhatsapp', title: 'Send Scheduling Whatsapp', icon: 'sms'},
      canSendScheduling && {id: 'SendSchedulingSms', title: 'Send Scheduling SMS', icon: 'message-outline'},
      !isCompleted && this.IAMPermissions.hasPermission('selfpickup.service.list') && {id: 'ScheduleSelfPickup', title: 'Schedule self pickup', icon: 'self-pickup'},
      !_.includes(['Total', 'Dispatched', 'OnHold'], status) && {id: 'BulkEdit', title: 'Bulk edit', icon: 'edit'}
    ]);

    this.footerActions = actions;
    this.footerExtraActions = isCompleted ? [] : [{id: 'Cancel', title: 'Cancel Orders', icon: 'close-circle-outline'}];
  }

  private _getSortType() {
    if (this.sortExternalIdType) {
      return 'externalId,' + this.sortExternalIdType;
    } else if (this.sortSlaType) {
      return 'dueTo,' + this.sortSlaType;
    } else if (this.sortAccountReferenceNameType) {
      return 'accountReference.name,' + this.sortAccountReferenceNameType
    } else if (this.sortCreatedAtType) {
      return 'createdAt,' + this.sortCreatedAtType;
    } else if (this.sortSchedulingSmsType) {
      return 'deliverySchedulingStateReference.lastSmsSentTimestamp,' + this.sortSchedulingSmsType;
    } else {
      return undefined;
    }
  }

  private setTotals() {
    this.totalsLoading = true;

    this.omsRequestsService.getOrdersTotals(this._getActiveFilter())
      .then((totals) => {
        this.totals = totals;
      })
      .catch((error) => {
        this.$log.error('Failed to get OMS totals', error);
      })
      .finally(() => {
        this.totalsLoading = false;
      });
  }

  private filterOrders(orders, dueDate, currentStatus) {
    dueDate = moment(dueDate).toDate();
    return _.filter(orders, (o) => {
      const orderDate = moment(o.dueTo).toDate();
      const isInRange = !moment(orderDate).isAfter(dueDate);
      const isSameStatus = !currentStatus || _.isEqual(o.status, currentStatus);
      return isInRange && isSameStatus;
    });
  }


  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

  private _getOrders() {
    this.excludeMode = false;
    this.selectedIds = [];
    this.selectedOrders = [];
    this.ordersFacadeService.clearStore();
    this.ordersFacadeService.getInfiniteScrollEntities(this._getOrdersQuery(), true);
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsOrdersView', {
    bindings: {
      dateRangeTemplateType: '<?',
      status: '<', // NotScheduled/Scheduled/Dispatched
      due: '<?',
      from: '<?',
      to: '<?',
      queryString: '<?',
      branchIds: '<?',
      accountIds: '<?',
      serviceAreaIds: '<?',
      noArea: '<?',
      tags: '<?',
      attempts: '<?',
      isPacked: '<?',
      obligateTimeWindow: '<?',
      schedulingRequired: '<?',
      fulfillmentDisplayStatus: '<?', // fulfillment display status
      noFromLocation: '<?',
      noToLocation: '<?',
      pickupDepotIds: '<?',
      destinationDepotIds: '<?',
      selectedQuickFilterId: '<?',
      programTypes: '<?',
      configuredFieldName: '<?',
      configuredFieldValue: '<?',
      addressQualities: '<?',
      schedulingSmsStatuses: '<?'
    },
    template: require('./oms-orders-view.html').default,
    controller: OmsOrdersViewController
  });
